import { Project } from '@material-bank/projects-api';
import { getAnalyticsItemCategoriesByTaxonomy } from './getAnalyticsItemCategoriesByTaxonomy';
import { ProductSearchMaterial } from '../../../../pages/ProductSearch/types';

export const mapProductToAnalyticsEcommerceItem = (params: {
  product: ProductSearchMaterial;
  itemListId?: string;
  itemListName?: string;
  index?: number;
  project?: Project;
}) => {
  const { product, itemListId, itemListName, index, project } = params;

  const colorway = product.colorVariants?.items?.find(
    (color) => color.image_url === product.thumbnailImageUrl?.split('?')?.[0],
  );
  const itemColor = colorway != null ? colorway?.exact_color : null;
  const finishesColor = product?.configData?.color;

  return {
    item_id: product.sku,
    item_name: product.name,
    item_brand: product.manufacturer,
    ...getAnalyticsItemCategoriesByTaxonomy(product.taxonomy),
    item_category4: product.industrySector || '',
    item_category5: project?.type?.label || '',
    index: product.gridIndex ?? product.index ?? index,
    price: 0,
    quantity: 1,
    item_list_id: itemListId,
    item_list_name: itemListName,
    item_variant: finishesColor ?? itemColor ?? '',
  };
};
